import React from 'react';
import { Box, Typography } from '@mui/material';
import { ReactComponent as NotFoundIcon } from '../../assets/images/not-found.svg';
import { ReactComponent as ForbiddenIcon } from '../../assets/images/forbidden.svg';
import PropTypes from 'prop-types';

export const NotFoundItems = ({ message, notFoundIcon = false }) => (
  <Box
    margin="auto"
    mt="200px"
    width="300px"
    display="flex"
    flexDirection="column"
    alignItems="center">
    <Box mb="24px">
      {message && !notFoundIcon ? <ForbiddenIcon data-testid="ForbiddenIcon" /> : <NotFoundIcon data-testid="NotFoundIcon" />}
    </Box>
    <Typography align="center" variant="h2" sx={{ color: 'grey.900' }} component="h2">
      {message ? message : 'По вашему запросу ничего не найдено'}
    </Typography>
  </Box>
);

NotFoundItems.propTypes = {
  message: PropTypes.string,
  notFoundIcon: PropTypes.bool
};
